import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {WizardsV3Service} from './wizards-v3.service';
import { Cacheable } from 'ts-cacheable';
import { CACHE_KEYS } from 'src/app/helpers/Cache';

@Injectable({
  providedIn: 'root'
})
export class Wizards2Service {

  constructor(
    private wizardsV3Service: WizardsV3Service
  ) {}

  @Cacheable({ cacheKey: CACHE_KEYS.wizardsCount })
  public getWizardsWidgetCount(data): Observable<any> {
    return this.wizardsV3Service.getWizardsWidgetCount(data);
  }

  @Cacheable({ cacheKey: CACHE_KEYS.wizardsLeads })
  public getWizardsLeads(data): Observable<any> {
    return this.wizardsV3Service.getWizardsLeads(data);
  }

}
